import Swiper from 'swiper';
import { Thumbs, Pagination, Navigation, Zoom } from 'swiper/modules';
import $ from 'jquery';
import 'swiper/css/bundle';

class BeverageGallery extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (this.querySelector('thumbnail-slider')) {
      var ThumbnailSlider = new Swiper(this.querySelector('thumbnail-slider'), {
        loop: false,
        slidesPerView: 6,
        freeMode: true,
        direction: 'vertical',
        observeParents: true,
        observer: true,
      });
    }

    var BeverageGallery = new Swiper(
      this.querySelector('.swiper-beverage-gallery'),
      {
        loop: false,
        rewind: true,
        zoom: true,
        autoHeight: true,
        spaceBetween: 10,
        slidesPerView: 1,
        observeParents: true,
        allowTouchMove: true,
        observer: true,
        modules: [Thumbs, Pagination, Navigation, Zoom],
        navigation: {
          nextEl: '.swipe-button-next',
          prevEl: '.swipe-button-prev',
        },
        pagination: {
          el: '.beverage-gallery-pagination',
          clickable: true,
        },
        thumbs: {
          swiper: ThumbnailSlider,
        },
        zoom: {
          maxRatio: 3,
          minRatio: 1,
        },
      }
    );

    BeverageGallery.on('slideChange', function () {
      const video = this.slides[this.activeIndex].querySelector('video');

      if (video != null) {
        video.currentTime = 0;
        video.play();
      }
    });

    // On initial load, check if there's a preselected featured image and slide to it
    BeverageGallery.on('init', function () {
      const preselectedSlide = this.el.querySelector(
        '.swiper-slide.preselected-featured-image'
      );
      if (preselectedSlide) {
        // Wait for Swiper to fully initialize and for slides to be processed
        setTimeout(() => {
          const visibleSlides = Array.from(this.slides).filter(
            (s) =>
              !s.classList.contains('!hidden') && s.style.display !== 'none'
          );
          const preselectedIndex = visibleSlides.indexOf(preselectedSlide);
          if (
            preselectedIndex !== -1 &&
            preselectedIndex !== this.activeIndex
          ) {
            this.slideTo(preselectedIndex, 0, false);
          }
        }, 200);
      }
    });

    // Also check after slides are ready (in case init fires too early)
    if (this.querySelector('.swiper-slide.preselected-featured-image')) {
      setTimeout(() => {
        const preselectedSlide = this.querySelector(
          '.swiper-slide.preselected-featured-image'
        );
        if (preselectedSlide && BeverageGallery) {
          const visibleSlides = Array.from(BeverageGallery.slides).filter(
            (s) =>
              !s.classList.contains('!hidden') && s.style.display !== 'none'
          );
          const preselectedIndex = visibleSlides.indexOf(preselectedSlide);
          if (
            preselectedIndex !== -1 &&
            preselectedIndex !== BeverageGallery.activeIndex
          ) {
            BeverageGallery.slideTo(preselectedIndex, 0, false);
          }
        }
      }, 300);
    }

    document.addEventListener('changeSlider', function (e) {
      // Variety packs render the gallery in a fixed server-side order
      // (front-of-can → back-of-can → comparison-chart → CASE → CASE-ART) and
      // have only one variant. Reordering on variant-change would push CASE to
      // position 0 and hide the can-front, so skip the entire reorder for VPs.
      const galleryHost = document.querySelector('beverage-gallery');
      if (galleryHost && galleryHost.dataset.isVp === 'true') {
        return;
      }

      let mediaIDs = [];
      let visibleSlides = [];

      // Normalize function for string comparison
      const normalizeString = (str) => {
        if (!str) return '';
        // Decode HTML entities if present
        const textarea = document.createElement('textarea');
        textarea.innerHTML = str;
        const decoded = textarea.value;
        // Normalize to NFC form (canonical composition) to handle encoding differences
        return decoded.normalize('NFC').trim();
      };

      const normalizedEventFlavor = normalizeString(e.detail.flavor_title);

      // Normalize the event media_id for comparison
      const eventUrl = e.detail.media_id.toString();
      const eventProtocolRelativeUrl = eventUrl.replace(/^https?:/, '');
      const normalizedEventMediaId = eventProtocolRelativeUrl.split('?')[0];

      // "* - Single" variants already lead with the can front (their featured
      // image IS the front of the can), so front-of-can slides are skipped for
      // them. size_value is the raw size option value from variant-button.
      const isSingleSize = /single/i.test(e.detail.size_value || '');

      // Don't hide/unhide slides here - we'll do it after finding the targetSlide
      // This prevents us from hiding the wrong slide or keeping the old slide visible

      const url = e.detail.media_id.toString();
      const protocolRelativeUrl = url.replace(/^https?:/, '');
      const normalizedEventMediaIdForSlide = protocolRelativeUrl.split('?')[0];

      // Find the slide element that matches the variant's featured image
      // IMPORTANT: Search through ALL slides (not just visible ones) to find the exact match
      let targetSlide = null;
      BeverageGallery.slides.forEach((slider) => {
        const sliderMediaId = slider.getAttribute('data-media-id');
        if (!sliderMediaId) return;

        const normalizedSliderMediaId = sliderMediaId.split('?')[0];
        const sliderProtocolRelativeUrl = sliderMediaId.replace(/^https?:/, '');
        const normalizedSliderProtocolRelativeUrl =
          sliderProtocolRelativeUrl.split('?')[0];

        // Match by normalized media ID (most reliable)
        // Compare both the normalized versions to handle protocol differences
        const matches =
          normalizedSliderMediaId === normalizedEventMediaIdForSlide ||
          normalizedSliderProtocolRelativeUrl ===
            normalizedEventMediaIdForSlide ||
          sliderMediaId === protocolRelativeUrl ||
          sliderProtocolRelativeUrl === protocolRelativeUrl ||
          sliderMediaId === url;

        if (matches) {
          targetSlide = slider;
          return; // Stop searching once we find a match
        }
      });

      // Find the index of the target slide in Swiper's visible slides array
      if (targetSlide) {
        const normalizedEventFlavor = normalizeString(e.detail.flavor_title);
        const swiperWrapper = BeverageGallery.slides[0]?.parentElement;

        // FIRST: Hide ALL slides
        BeverageGallery.slides.forEach((slider) => {
          slider.classList.add('!hidden');
        });

        // SECOND: Collect slides to show in correct order: variant image, back of can, front of can, b-plus, comparison chart
        const slidesToShow = [targetSlide]; // Variant image first
        const backOfCanSlides = [];
        const frontOfCanSlides = [];
        const comparisonChartSlides = [];
        const bPlusSlides = [];

        // Find back of can and comparison chart slides for the selected size
        BeverageGallery.slides.forEach((slider) => {
          const sliderMediaId = slider.getAttribute('data-media-id');
          if (!sliderMediaId) return;

          // Skip if this is the variant image (already in slidesToShow)
          const normalizedSliderMediaId = sliderMediaId.split('?')[0];
          const sliderProtocolRelativeUrl = sliderMediaId.replace(
            /^https?:/,
            ''
          );
          const normalizedSliderProtocolRelativeUrl =
            sliderProtocolRelativeUrl.split('?')[0];
          const isFeaturedImage =
            normalizedSliderMediaId === normalizedEventMediaIdForSlide ||
            normalizedSliderProtocolRelativeUrl ===
              normalizedEventMediaIdForSlide ||
            sliderMediaId === protocolRelativeUrl ||
            sliderProtocolRelativeUrl === protocolRelativeUrl ||
            sliderMediaId === url ||
            slider === targetSlide;

          if (!isFeaturedImage) {
            // Variant/pack images (product.media and the server-rendered
            // preselected featured-image copy) also carry data-flavor/data-size,
            // so without this guard the type fallback below would misclassify a
            // stale pack image as the comparison chart and re-show it at the end
            // of the carousel. They are shown/hidden by the FOURTH pass instead.
            // The class check covers edge-cached HTML rendered before
            // data-is-variant-image was stamped on the preselected slide.
            if (
              slider.getAttribute('data-is-variant-image') === 'true' ||
              slider.classList.contains('preselected-featured-image')
            ) {
              return;
            }

            const sliderFlavor = slider.getAttribute('data-flavor');
            const sliderSize = slider.getAttribute('data-size');

            // Check if this slide matches the current flavor and size
            if (sliderFlavor) {
              const normalizedSliderFlavor = normalizeString(sliderFlavor);
              const sizeMatch = sliderSize === e.detail.flavor_size;
              const flavorMatch =
                normalizedSliderFlavor === normalizedEventFlavor;

              if (flavorMatch && sizeMatch) {
                // Use data-slide-type attribute for reliable identification
                const slideType = slider.getAttribute('data-slide-type');

                if (slideType === 'back-of-can') {
                  backOfCanSlides.push(slider);
                } else if (slideType === 'front-of-can') {
                  // Rendered only for flavors whose side-of-can art was removed
                  // (back_of_can_* blank). Skipped for Single variants — no
                  // duplicate can front next to the variant's own image.
                  if (!isSingleSize) {
                    frontOfCanSlides.push(slider);
                  }
                } else if (slideType === 'comparison-chart') {
                  comparisonChartSlides.push(slider);
                } else if (slideType === 'b-plus') {
                  bPlusSlides.push(slider);
                } else {
                  // Fallback: try to detect from URL if data-slide-type is missing
                  const isBackOfCan =
                    sliderMediaId.includes('Can_sideA') ||
                    sliderMediaId.includes('back');
                  if (isBackOfCan) {
                    backOfCanSlides.push(slider);
                  } else {
                    // If it matches the current selection, is not a variant image
                    // (excluded above), and is not back of can, it must be the
                    // comparison chart
                    comparisonChartSlides.push(slider);
                  }
                }
              }
            }
          }
        });

        // Add back of can, front of can, b-plus, and comparison chart to slidesToShow in correct order
        // (back and front never coexist for the same flavor+size — front renders only when back is blank)
        slidesToShow.push(...backOfCanSlides);
        slidesToShow.push(...frontOfCanSlides);
        slidesToShow.push(...bPlusSlides);
        slidesToShow.push(...comparisonChartSlides);

        // FOURTH: Explicitly hide all variant images (from product.media) that are
        // NOT the target slide. These slides carry data-is-variant-image="true" from
        // the server render (see beverage-gallery.liquid), so key off that flag
        // rather than sniffing the filename for "6pk"/"12pk"/etc. Filename sniffing
        // missed any pack image whose URL didn't contain those exact tokens, leaving
        // the previous selection's pack image visible at the end of the carousel when
        // a pack size was carried over from another flavor/size selection.
        BeverageGallery.slides.forEach((slider) => {
          const sliderMediaId = slider.getAttribute('data-media-id');
          if (!sliderMediaId) return;

          // Primary: reliable server-rendered marker.
          // Fallback: legacy filename sniff for any slide missing the attribute.
          const isVariantImage =
            slider.getAttribute('data-is-variant-image') === 'true' ||
            sliderMediaId.includes('6pk') ||
            sliderMediaId.includes('12pk') ||
            sliderMediaId.includes('8pk') ||
            sliderMediaId.includes('FRONT_3_4_FACING');

          if (isVariantImage && slider !== targetSlide) {
            // Hide all variant images except the target slide
            slider.classList.add('!hidden');
            slider.style.display = 'none';
          }
        });

        // FIFTH: Unhide all slides that should be visible FIRST (before reordering)
        slidesToShow.forEach((slider) => {
          slider.classList.remove('!hidden');
          slider.style.display = ''; // Remove any inline display:none
        });

        // FIFTH-B: Explicitly hide ALL slides with wrong size (regardless of flavor)
        // This ensures that when switching products, old size slides are properly hidden
        BeverageGallery.slides.forEach((slider) => {
          const sliderSize = slider.getAttribute('data-size');
          if (sliderSize && sliderSize !== e.detail.flavor_size) {
            // This slide has the wrong size, hide it
            slider.classList.add('!hidden');
            slider.style.display = 'none';
          }
        });

        // SIXTH: Reorder DOM elements so variant image is first, then back of can, then comparison chart
        if (swiperWrapper) {
          // Move variant image to first position
          if (targetSlide.parentElement === swiperWrapper) {
            swiperWrapper.insertBefore(targetSlide, swiperWrapper.firstChild);
          }

          // Move back of can slides after variant image
          backOfCanSlides.forEach((slide, index) => {
            if (slide.parentElement === swiperWrapper) {
              const insertAfter =
                index === 0 ? targetSlide : backOfCanSlides[index - 1];
              if (insertAfter.nextSibling) {
                swiperWrapper.insertBefore(slide, insertAfter.nextSibling);
              } else {
                swiperWrapper.appendChild(slide);
              }
            }
          });

          // Move front of can slides after back of can
          frontOfCanSlides.forEach((slide, index) => {
            if (slide.parentElement === swiperWrapper) {
              const insertAfter =
                index === 0
                  ? backOfCanSlides[backOfCanSlides.length - 1] || targetSlide
                  : frontOfCanSlides[index - 1];
              if (insertAfter.nextSibling) {
                swiperWrapper.insertBefore(slide, insertAfter.nextSibling);
              } else {
                swiperWrapper.appendChild(slide);
              }
            }
          });

          // Move b-plus slides after front of can
          bPlusSlides.forEach((slide, index) => {
            if (slide.parentElement === swiperWrapper) {
              const lastCanSlide =
                frontOfCanSlides[frontOfCanSlides.length - 1] ||
                backOfCanSlides[backOfCanSlides.length - 1] ||
                targetSlide;
              if (lastCanSlide.nextSibling) {
                swiperWrapper.insertBefore(slide, lastCanSlide.nextSibling);
              } else {
                swiperWrapper.appendChild(slide);
              }
            }
          });

          // Move comparison chart slides after b-plus
          comparisonChartSlides.forEach((slide, index) => {
            if (slide.parentElement === swiperWrapper) {
              const lastBPlus =
                bPlusSlides[bPlusSlides.length - 1] ||
                frontOfCanSlides[frontOfCanSlides.length - 1] ||
                backOfCanSlides[backOfCanSlides.length - 1] ||
                targetSlide;
              if (lastBPlus.nextSibling) {
                swiperWrapper.insertBefore(slide, lastBPlus.nextSibling);
              } else {
                swiperWrapper.appendChild(slide);
              }
            }
          });
        }

        // SEVENTH: Update Swiper to reflect the DOM changes
        BeverageGallery.update();

        // EIGHTH: Wait for Swiper to update, then slide to index 0 (variant image)
        requestAnimationFrame(() => {
          // Get visible slides after update
          const visibleSlides = Array.from(BeverageGallery.slides).filter(
            (s) =>
              !s.classList.contains('!hidden') && s.style.display !== 'none'
          );

          // Find the index of the target slide in visible slides (should be 0 after reordering)
          const targetIndex = visibleSlides.indexOf(targetSlide);

          if (targetIndex !== -1) {
            // Slide to the variant image
            BeverageGallery.slideTo(
              targetIndex,
              e.detail.transition_speed,
              false
            );
          } else {
            // Fallback: slide to index 0
            BeverageGallery.slideTo(0, e.detail.transition_speed, false);
          }
        });
      } else {
        BeverageGallery.slideTo(0, e.detail.transition_speed, false);
      }
    });
  }
}

customElements.define('beverage-gallery', BeverageGallery);
